<ng-content></ng-content>
<span *ngIf="address?.streetAddress1">{{ address.streetAddress1 }}</span>
<span *ngIf="address?.streetAddress2">{{ address.streetAddress2 }}</span>
<span *ngIf="address?.getAddressLine3()">{{ address.getAddressLine3() }}</span>
<span *ngIf="address?.country">{{ address.country | countryName | async }}</span>
<span *ngIf="address.validationStatus && !hideStatus" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
  <mat-icon *ngIf="address.validationStatus === 'Success'" class="success">check_circle</mat-icon>
  <mat-icon *ngIf="address.validationStatus === 'Warning'" color="accent">warning</mat-icon>
  <mat-icon *ngIf="address.validationStatus === 'Error'" color="error">warning</mat-icon>
  <span>{{ address.validationMessage }}</span>
</span>
